import { NavLink, Outlet } from 'react-router-dom'
import { useAuth } from '@/api/auth'
import { cn } from '@/lib/utils'

/** Lager-Navi (Plan 2026-10-23 S3): Pfad-Reiter, weil LeerplatzPage `?tab=` selbst nutzt. */
const REITER: { to: string; label: string; end?: boolean; lead?: boolean }[] = [
  { to: '/warehouse/lager-navi', label: 'Suche', end: true },
  { to: '/warehouse/lager-navi/regale', label: 'Regale' },
  { to: '/warehouse/lager-navi/leere-plaetze', label: 'Leere Plätze', lead: true },
  { to: '/warehouse/lager-navi/plaetze', label: 'Plätze' },
]

export default function LagerNaviLayout() {
  const { warehouse } = useAuth()
  return <div className="min-h-full">
    <div className="px-4 pt-4 max-w-7xl mx-auto">
      <h1 className="text-xl font-bold">Lager-Navi</h1>
      <p className="text-sm text-ink-2 mt-1">Wo liegt ein Artikel, wie sind die Regale belegt.</p>
      <nav aria-label="Lager-Navi" className="mt-3 flex gap-1 overflow-x-auto border-b border-line">
        {REITER.filter(r => !r.lead || warehouse.lead).map(r => (
          <NavLink key={r.to} to={r.to} end={r.end}
            className={({ isActive }) => cn('px-3 py-2 text-sm whitespace-nowrap border-b-2 -mb-px focus-visible:outline-2 focus-visible:outline-primary',
              isActive ? 'border-primary text-ink font-semibold' : 'border-transparent text-ink-2 hover:text-ink')}>
            {r.label}
          </NavLink>
        ))}
      </nav>
    </div>
    <Outlet />
  </div>
}
